import { StyledReactSelect } from '@fountain/fountain-ui-components';
import { Grid } from '@material-ui/core';
import { produce } from 'immer';
import React, { FC, useContext } from 'react';
import { useIntl } from 'react-intl';

import { getConditionErrorMessage } from 'containers/WorkflowEditor/components/Rules/Condition/constants';
import { RulesEditDataContext } from 'containers/WorkflowEditor/contexts/rulesEditDataContext';
import globalMessages from 'shared/global/messages';

import { DocumentSigningRuleProps } from '../../DocumentSigningRules/types';
import { RulesProps, SharedConditionProps } from '../../types';
import { messages } from '../messages';

export const RehireStatus: FC<SharedConditionProps> = ({
  condition,
  ruleId,
  setRules,
  setDocumentSigningRules,
  errors,
}) => {
  const intl = useIntl();
  const { condition_statuses: conditionStatuses } =
    useContext(RulesEditDataContext);

  const statusMessages = {
    eligible: intl.formatMessage(messages.rehireStatusEligible),
    not_eligible: intl.formatMessage(messages.rehireStatusNotEligible),
    no_match: intl.formatMessage(messages.rehireStatusNoMatch),
    currently_employed: intl.formatMessage(
      messages.rehireStatusCurrentlyEmployed,
    ),
    needs_review: intl.formatMessage(messages.rehireStatusNeedsReview),
  };
  const statusOptions = conditionStatuses?.rehire_check?.map(status => ({
    label: statusMessages[status],
    value: status,
  }));
  const selectedStatus =
    statusOptions?.find(option => option.value === condition.extra.status) ??
    null;

  const onChangeStatus = (newStatus: { label: string; value: string }) => {
    const rulesSetter = setRules ?? setDocumentSigningRules;
    if (!rulesSetter) return;

    rulesSetter(
      produce((draftRules: RulesProps | DocumentSigningRuleProps) => {
        const draftConditions =
          draftRules[ruleId]?.condition_set_attributes?.conditions_attributes ??
          [];
        const index = draftConditions.findIndex(
          item => item.id === condition.id,
        );

        draftConditions[index].extra.status = newStatus.value;
      }),
    );
  };

  const statusErrorMessage =
    !condition.extra.status && getConditionErrorMessage('status', errors);

  return (
    <Grid item xs={6}>
      <StyledReactSelect
        options={statusOptions}
        label={intl.formatMessage(globalMessages.status)}
        aria-label={intl.formatMessage(globalMessages.status)}
        onChange={onChangeStatus}
        value={selectedStatus}
        error={statusErrorMessage}
        placeholder=""
        required
      />
    </Grid>
  );
};
